import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { shallowEqual } from 'react-redux';
import { ScaledTextButton } from '../../../../components/scaledTextButton';
import { isConfigFlagEnabled } from '../../../../config';
import { useSocketSend } from '../../../../context/webSocket/webSocketContext';
import { selectTotalPotSize } from '../../../../redux/reducers/pokerReducer';
import { useAppSelector } from '../../../../redux/store';
import { ALL_SIMPLE_BET_ACTION_PROPERTIES, createAllSimpleBetButtonProperties, splitSimpleBetButtonsIntoGroups } from '../simpleBetUtils';
function renderSimpleBetButtonsGroup(groupButtonsProperties, groupBounds, isDoubleRow, maxButtonSlots) {
    const numButtonColumns = Math.ceil(maxButtonSlots / (isDoubleRow ? 2 : 1));
    const buttonW = Math.round(groupBounds.w / numButtonColumns);
    const buttonH = isDoubleRow ? Math.round(groupBounds.h / 2) : groupBounds.h;
    return (_jsx(_Fragment, { children: groupButtonsProperties.map(({ simpleBetActionType, label, subLabel, onClick, accentColor }, i) => {
            const rowIndex = Math.floor(i / numButtonColumns);
            const columnIndex = i % numButtonColumns;
            const bounds = {
                x: groupBounds.x + columnIndex * buttonW + buttonW / 2,
                y: groupBounds.y + rowIndex * buttonH + buttonH / 2,
                w: buttonW,
                h: buttonH
            };
            const { testId } = ALL_SIMPLE_BET_ACTION_PROPERTIES[simpleBetActionType];
            return (_jsx(ScaledTextButton, { onClick: onClick, label: label, subLabel: subLabel, x: bounds.x, y: bounds.y, w: bounds.w, h: bounds.h, accentColor: accentColor, testId: testId }, i));
        }) }));
}
export const DomSimpleBetControls = ({ myTurnProperties }) => {
    const mainBetControlsBounds = useAppSelector((state) => state.gameDimensions.mainBetControlsBounds, shallowEqual);
    const totalPotSize = useAppSelector(selectTotalPotSize);
    const socketSend = useSocketSend();
    if (!isConfigFlagEnabled('domBetButtons')) {
        return null;
    }
    if (!mainBetControlsBounds) {
        return null;
    }
    const allButtonProperties = createAllSimpleBetButtonProperties(myTurnProperties, totalPotSize, socketSend);
    /**
     * Split simple betting buttons into two groups.
     * This allows the 'passive' buttons (fold, call, check) to be rendered with a consistent size / placement
     * so that auto-betting controls can be consistently overlayed in these areas even if the number of available
     * 'aggressive' buttons (bet, raise, all-in) changes, as those are rendered with different sizing / placement
     * logic.
     */
    const { passiveButtonProperties, aggressiveButtonProperties } = splitSimpleBetButtonsIntoGroups(allButtonProperties);
    const passiveButtonGroupBounds = {
        ...mainBetControlsBounds,
        w: mainBetControlsBounds.w / 6
    };
    const aggressiveButtonGroupBounds = {
        ...mainBetControlsBounds,
        x: mainBetControlsBounds.x + passiveButtonGroupBounds.w,
        w: mainBetControlsBounds.w - passiveButtonGroupBounds.w
    };
    return (_jsxs(_Fragment, { children: [renderSimpleBetButtonsGroup(passiveButtonProperties, passiveButtonGroupBounds, true, 2), renderSimpleBetButtonsGroup(aggressiveButtonProperties, aggressiveButtonGroupBounds, true, 6)] }));
};
